import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Tabs } from '../components/StoreTabs';
import { useAuth } from '../auth/useAuth';
import { makeApi } from '../api/client';
import { ActivationCodeDialog } from '../components/ActivationCodeDialog';

export default function StoreDetailRoute() {
  const { id } = useParams<{ id: string }>();
  const { getAccessToken } = useAuth();
  const api = makeApi(getAccessToken);
  // No GET /org/stores/:id in contract — use list + filter
  const q = useQuery({
    queryKey: ['store', id],
    queryFn: async () => {
      const result = await api.org.listStores({ query: { limit: 100 } });
      return result.data?.items?.find((s) => s.id === id) ?? null;
    },
    enabled: !!id,
  });
  const [activationOpen, setActivationOpen] = useState(false);
  if (!q.data) return <div role="status">Loading…</div>;
  const store = q.data;
  return (
    <section>
      <h1 className="text-2xl font-bold text-primary mb-4">{store.name}</h1>
      <Tabs tabs={[
        { key: 'overview', label: 'Overview', content: (
          <dl className="space-y-2 text-sm">
            <div><dt className="font-semibold">Status</dt><dd>{store.status}</dd></div>
            <div><dt className="font-semibold">Address</dt><dd>{store.address ?? '—'}</dd></div>
            <div><dt className="font-semibold">GSTIN</dt><dd>{store.gstin ?? '—'}</dd></div>
          </dl>
        )},
        { key: 'activation', label: 'Activation', content:
          <button onClick={() => setActivationOpen(true)} className="rounded bg-accent px-4 py-2 text-white">Generate activation code</button> },
        { key: 'devices', label: 'Devices', content:
          <p className="text-ink/60">No devices activated yet.</p> },
        { key: 'warehouses', label: 'Warehouses', content: <p className="text-ink/60">Linked warehouses appear here.</p> },
      ]} />
      {id && <ActivationCodeDialog storeId={id} open={activationOpen} onClose={() => setActivationOpen(false)} />}
    </section>
  );
}
